import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { TeamEarningsWidget } from '@zet/my-teams/src/components/teamEarningsWidget'

import { useMyTeamsEarningsTotal } from '../../../api/earnings/hooks'
import { usePaymentDetails } from '../../../api/paymentModes/hooks'
import { i18n } from '../../../localization'

type Props = {
  isProfileScreen?: boolean
}

const EarningWidgetContainer = ({ isProfileScreen }: Props) => {
  const { data: totalEarnings } = useMyTeamsEarningsTotal()
  const { data: paymentMode } = usePaymentDetails()
  const { navigate } = useNavigation()
  const onViewAll = () => {
    navigate('TeamEarningsPage')
  }
  const onAddAccount = () => {
    if (isProfileScreen && paymentMode?.accountNumber) {
      navigate('EditBankAccountDetails')
    } else {
      navigate('AddBankAccount')
    }
  }
  let showWarning
  if (
    !paymentMode?.accountNumber &&
    totalEarnings?.total &&
    totalEarnings?.total > 0
  ) {
    showWarning = true
  } else {
    showWarning = false
  }
  return (
    <TeamEarningsWidget
      amount={totalEarnings?.total}
      viewAllButtonAction={onViewAll}
      accountButtonAction={onAddAccount}
      showAccountButton={showWarning || isProfileScreen}
      accountButtonText={
        isProfileScreen && !showWarning
          ? i18n.t('myTeamsEarningsWidget.viewBankAccountDetails')
          : i18n.t('myTeamsEarningsWidget.addBankAccount')
      }
      showWarning={showWarning}
      title={i18n.t('myTeamsEarningsWidget.myEarnings')}
    />
  )
}

export default EarningWidgetContainer
